import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'
import { useConfigTypeTitle } from '@eggplant/routing'

const TestConfigSutsTypeInfo = () => {
  const configTypeText = useConfigTypeTitle()

  return (
    <>
      <Header rank={4}>
        System Under Test (SUT)
      </Header>
      <Paragraph>
        <Color
          display='inline'
          variant='theme-description-text'
        >
          The software application, system, or component being tested. Set up in the SUTs page. You can configure SUTs in a {configTypeText} configuration in the following ways:
          <br /><br />
          <strong>
            None
          </strong>
          <br />
          SUT selection is handled in code or this test doesn't require a SUT.
          <br /><br />
          <strong>
            By name
          </strong>
          <br />
          Select a specific SUT by its name.
          <br /><br />
          <strong>
            By SUT tags
          </strong>
          <br />
          Select an available SUT that matches all selected tags defined in its settings.
          <br /><br />
          <strong>
            Eggplant Cloud
          </strong>
          <br />
          Use a SUT hosted by Eggplant. Only applicable in Eggplant Cloud environments.
          <br /><br />
        </Color>
        <LinkToDocusaurus path={testConfig}>Learn more in the DAI documentation</LinkToDocusaurus>
      </Paragraph>
    </>
  )
}

export default TestConfigSutsTypeInfo
